import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';
import { DashboardService } from 'src/app/core/dashboard/dashboard.service';
import { AppStateInterface } from '../types';
import * as SettingsDataActions from './actions';
import { successSettingsDataSelector } from './selectors';

@Injectable()
export class SettingsDataEffect {
  // this effect fetches data from API evertyme it is called
  getSettingsData$ = createEffect(()=>
  this.actions$.pipe(
    ofType(SettingsDataActions.getSettingsData),
    withLatestFrom(this.store.select(successSettingsDataSelector)),
    switchMap(([action, settingsDataSuccess]) => {
      if (settingsDataSuccess) {
        return of(
          SettingsDataActions.getSettingsDataSuccessAlreadyLoaded(
            settingsDataSuccess,
          ),
        );
      }
      return this.dashboardService.getSettingsData().pipe(
        map((settingsData) => SettingsDataActions.getSettingsDataSuccess(settingsData)),
        catchError((error) => of(SettingsDataActions.getSettingsDataFailure({error: error.message})))
      )
    })
    )
  )

  constructor(
    private actions$: Actions,
    private dashboardService: DashboardService,
    private store: Store<AppStateInterface>,
  ) {}
}
